import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Table } from 'reactstrap';

import ListFromApi from '../../../ListFromApi';
import OrganiserRow from './OrganiserRow';

function Organisers(props) {
    const { id } = useParams();

    return (
        <Row>
            <Col>
                <h4>Rendezői jelentkezések</h4>
                <Table size="sm" responsive striped>
                    <thead>
                        <tr>
                            <th>Tisztség</th>
                            <th>Név</th>
                            <th>Állapot</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ListFromApi url={`/events/${id}/registrations/organisers`}
                            errorMessage='A rendezői jelentkezések letöltése sikertelen.'
                            elementType={OrganiserRow}
                        />
                    </tbody>
                </Table>
            </Col>
        </Row>
    );
}

export default Organisers;